module.exports = __webpack_public_path__ + "img/cognitive_img09.d6a14873.png";